export default "__VITE_ASSET__BFAWBdNS__"